/**
 * Mobile-only click-through arrows for the testimonials carousel
 * (sections/je-testimonials.liquid, .je-tm__grid below 990px — one card
 * fully visible at a time). Same pattern as assets/je-feature-grid.js,
 * scoped per .je-tm section rather than a hardcoded id.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.je-tm').forEach((section) => {
    const grid = section.querySelector('.je-tm__grid');
    const prevBtn = section.querySelector('[data-je-tm-prev]');
    const nextBtn = section.querySelector('[data-je-tm-next]');
    if (!grid || !prevBtn || !nextBtn) return;

    function cardStep() {
      const card = grid.querySelector('.je-tm__cell');
      if (!card) return grid.clientWidth;
      const style = window.getComputedStyle(grid);
      const gap = parseFloat(style.columnGap || style.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateDisabledState() {
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      prevBtn.disabled = grid.scrollLeft <= 1;
      nextBtn.disabled = grid.scrollLeft >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', () => {
      grid.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      grid.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateDisabledState, { passive: true });
    window.addEventListener('resize', updateDisabledState);
    updateDisabledState();
  });
});
